import { useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { DashboardPillBar } from "@/components/dashboard/DashboardPillBar";
import { DashboardOverlay, type DashboardTab } from "@/components/dashboard/DashboardOverlay";
import { DashboardChatCard } from "@/components/dashboard/DashboardChatCard";
import { DashboardNotesCard } from "@/components/dashboard/DashboardNotesCard";
import { AutomatedActivityCard } from "@/components/dashboard/AutomatedActivityCard";

const LAST_TAB_STORAGE_KEY = "dashboard-last-tab";

export default function DashboardPage() {
  const { user } = useAuth();
  const firstName = user?.firstName || user?.email?.split("@")[0] || "there";

  const [overlayTab, setOverlayTab] = useState<DashboardTab | null>(null);

  function openTab(slug: DashboardTab) {
    setOverlayTab(slug);
    window.localStorage.setItem(LAST_TAB_STORAGE_KEY, slug);
  }

  return (
    <div className="space-y-5">
      <h1 className="text-3xl font-semibold tracking-tight">Hello, {firstName}</h1>

      <DashboardPillBar onOpenTab={openTab} />

      <div className="grid gap-4 md:grid-cols-2">
        <DashboardChatCard />
        <DashboardNotesCard />
      </div>

      <AutomatedActivityCard />

      <DashboardOverlay
        open={overlayTab !== null}
        activeTab={overlayTab}
        onTabChange={(t) => openTab(t)}
        onClose={() => setOverlayTab(null)}
      />
    </div>
  );
}
